import React, { useEffect, useRef, useState } from "react";
import ItemsSearchAddFeild from "../../forms/items-search-add-field";
import {
  producBatchDetailsAction,
  productListAction,
} from "../../../redux/actions/general-action";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../../helper-components/overlay-loading";
import ItemsInputField from "../../forms/items-input-field";

import moment from "moment";
import errorToast from "../../helper-components/error-toast";
import AddButton from "../../buttons/button";
import DeleteIcon from "../../../assets/icons/delete-icon";
import BatchSelectionModal from "../../invoice-section/billing-batch-selection-modal";
// import ChangeBatchField from "./change-batch";
// import BatchSelectionModal from "../billing-batch-selection-modal";

const AuditItemsSection = ({
  initialValues,
  searchRef,
  setSelectedItem,
  selectedItem,
  disabled,
  corr_ref,
  setBatchModalOpen,
  batchModalOpen,
  setLoading,
}) => {
  // const [batchModalOpen, setBatchModalOpen] = useState(false);

  const [isLoadingOverlay, setIsLoadingOverlay] = useState(false);
  const [heading, setHeading] = useState([]);
  const [batchheading, setBatchHeading] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  useEffect(() => {
    // setLoading(true);
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const auditHeading = parsed.find((obj) => obj?.stock_audit_create);
      if (auditHeading?.stock_audit_create) {
        setHeading(auditHeading.stock_audit_create);
        setLoading(false);
      }
      const batchData = parsed.find((obj) => obj?.bill_create_batch_pop_up);
      if (batchData?.bill_create_batch_pop_up) {
        setBatchHeading(batchData.bill_create_batch_pop_up);
      }
    }
  }, []);

  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      let rows = data?.data === null ? [] : data.data;
      rows = rows.map((item) => ({
        value: item.item_id,
        label: (
          <div
            style={{
              minHeight: "38px",
              display: "grid",
              gridTemplateColumns: "12% 38% 10% 10% 10% 10% 10%",
              padding: "8px 16px",
              alignItems: "center",
              fontSize: "var(--items-search-drop-row-fs)",
              fontWeight: "var(--items-search-drop-row-fw)",
              color: "var(--items-search-drop-row-fg)",
            }}
          >
            <span>{item.item_code}</span>
            <span
              style={{
                maxWidth: "250px",
                // overflow: "hidden",
                whiteSpace: "wrap",
                // textOverflow: "ellipsis",
              }}
            >
              {item.item_name}
            </span>
            <div className="flex items-center gap-2">
              <span
                className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${
                  parseFloat(item?.total_sellable_quantity) > 10
                    ? "bg-[var(--pill-badge-green-bg)]"
                    : "bg-[var(--pill-badge-red-bg)]"
                }`}
              >
                {parseFloat(item?.total_sellable_quantity)}
              </span>
            </div>
            <span style={{ textAlign: "center" }}>
              {item.item_batch_final_purchase_rate ?? "N/A"}
            </span>
            <span style={{ textAlign: "center" }}>
              {item.tax_rate ?? "N/A"}
            </span>
            <span style={{ textAlign: "center" }}>
              {item.item_selling_price ?? "N/A"}
            </span>
            <span style={{ textAlign: "center" }}>
              {item.item_unit_price ?? "N/A"}
            </span>
          </div>
        ),
        item_name: item?.item_name,
        availableQty: item?.total_sellable_quantity,
        batches: item?.batches?.length,
      }));

      setLocalData(data.data);

      callback([
        {
          label: (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "12% 38% 10% 10% 10% 10% 10%",
                padding: "8px 16px",
                position: "sticky",
                top: 0,
                zIndex: 10,
                backgroundColor: "var(--items-search-drop-head-bg)",
                color: "var(--items-search-drop-head-fg)",
                fontWeight: "var(--items-search-drop-head-fw)",
                fontSize: "var(--items-search-drop-head-fs)",
                borderBottom: "1px solid var(--items-search-drop-border)",
                alignItems: "center",
                height: "38px",
              }}
            >
              <span>Item Code</span>
              <span>Item Name</span>
              <span style={{ textAlign: "center" }}>Avil Qty</span>
              <span style={{ textAlign: "center" }}>Pur Price</span>
              <span style={{ textAlign: "center" }}>GST %</span>
              <span style={{ textAlign: "center" }}>Rate</span>
              <span style={{ textAlign: "center" }}>MRP</span>
            </div>
          ),
          options: rows,
        },
      ]);
    };

    const onError = () => {};

    if (inputValue?.length > 0) {
      dispatch(
        productListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const removeRow = (rowIndex, type = "") => {
    let updatedData = [...values.stockAuditRecordData];

    if (type === "all") {
      // If type is "all", clear all rows
      updatedData = [];
    } else {
      // Otherwise, remove specific row
      updatedData.splice(rowIndex, 1);
    }
    const total_items_count = updatedData.length;

    const total_matched_item = updatedData.filter(
      (row) =>
        parseFloat(row.item_quantity || 0) ===
        parseFloat(row.updated_quantity || 0)
    ).length;

    const total_miss_matched_item = total_items_count - total_matched_item;

    let total_added_item_value = 0;
    let total_removed_item_value = 0;

    updatedData.forEach((row) => {
      const diff = parseFloat(row.item_current_adjusted_diff || 0);
      if (diff > 0) total_added_item_value += diff;
      else total_removed_item_value += Math.abs(diff);
    });

    const total_item_net_difference =
      total_added_item_value - total_removed_item_value;
    // Update the data
    setFieldValue("stockAuditRecordData", updatedData);
    setFieldValue("total_items_count", total_items_count);
    setFieldValue("total_matched_item", total_matched_item);
    setFieldValue("total_miss_matched_item", total_miss_matched_item);
    setFieldValue("total_added_item_value", total_added_item_value.toFixed(2));
    setFieldValue(
      "total_removed_item_value",
      total_removed_item_value.toFixed(2)
    );
    setFieldValue(
      "total_item_net_difference",
      total_item_net_difference.toFixed(2)
    );
  };

  const onSuccessBatchDetails = (data, filteredData) => {
    setIsLoadingOverlay(false);
    const updatedTempRowData = {
      ...filteredData,
      item_Batch_List: data?.data || [],
    };
    setFieldValue("tempRowData", updatedTempRowData);
    setBatchModalOpen(true);
  };

  const onErrorDetails = (data) => {
    setIsLoadingOverlay(false);
  };

  const auditFn = async (item) => {
    let updatedData = [...(values?.stockAuditRecordData ?? [])];
    const item_current_amount = (
      parseFloat(item?.item_quantity || 0) *
      parseFloat(item?.item_batch_purchase_rate || 0)
    ).toFixed(2);
    const item_total_amount =
      parseFloat(item?.updated_quantity || 0) *
      parseFloat(item?.item_batch_purchase_rate || 0);

    const item_adjusted_amount =
      parseFloat(item_total_amount) - item_current_amount;
    const item_current_adjusted_diff = item_adjusted_amount.toFixed(2);
    const correction = item_adjusted_amount === 0 ? "+" : "-";

    const updatedDataRow = {
      ...item,
      item_current_amount,
      item_total_amount: parseFloat(item_total_amount).toFixed(2),
      item_adjusted_amount: item_adjusted_amount.toFixed(2),
      item_current_adjusted_diff,
      correction,
    };

    // Remove existing entry for the same item + batch
    updatedData = updatedData?.filter(
      (existingItem) =>
        !(
          existingItem.item_id === item.item_id &&
          existingItem.item_batch_number === item?.item_batch_number &&
          existingItem?.item_rack_location === item?.item_rack_location
        )
    );

    updatedData.push(updatedDataRow);

    // ✅ Summary Calculations
    const total_items_count = updatedData.length;

    const total_matched_item = updatedData.filter(
      (row) =>
        parseFloat(row.item_quantity || 0) ===
        parseFloat(row.updated_quantity || 0)
    ).length;

    const total_miss_matched_item = total_items_count - total_matched_item;

    let total_added_item_value = 0;
    let total_removed_item_value = 0;

    updatedData.forEach((row) => {
      const diff = parseFloat(row.item_current_adjusted_diff || 0);
      if (diff > 0) total_added_item_value += diff;
      else total_removed_item_value += Math.abs(diff);
    });

    const total_item_net_difference =
      total_added_item_value - total_removed_item_value;

    // ✅ Set Form Values
    setFieldValue("stockAuditRecordData", updatedData);
    setFieldValue("tempRowData", initialValues?.tempRowData);
    setFieldValue("total_items_count", total_items_count);
    setFieldValue("total_matched_item", total_matched_item);
    setFieldValue("total_miss_matched_item", total_miss_matched_item);
    setFieldValue("total_added_item_value", total_added_item_value.toFixed(2));
    setFieldValue(
      "total_removed_item_value",
      total_removed_item_value.toFixed(2)
    );
    setFieldValue(
      "total_item_net_difference",
      total_item_net_difference.toFixed(2)
    );

    setIsLoadingOverlay(false);
    if (searchRef?.current) {
      setTimeout(() => {
        searchRef.current.focus();
      }, 0);
    }
  };

  return (
    <div
      style={{
        maxHeight: `calc(100% - 8.5rem)`, // Limit the container height
        height: "auto", // Let it grow naturally to fit its content
      }}
      className={`border border-[var(--create-table-main-border)] border-1 border-radius px-3 pb-3`}
    >
      {!disabled && (
        <div className="flex items-center justify-between w-full h-[5.5rem]">
          {["item_code", "item_name"].map((fieldType, index) => (
            <div
              key={fieldType}
              className={
                index === 0
                  ? "max-w-[10%] min-w-[10%]"
                  : "max-w-[25%] min-w-[25%]"
              }
            >
              <ItemsSearchAddFeild
                label={fieldType === "item_code" ? "Item Code" : "Product Name"}
                isDisabled={disabled}
                searchRef={index === 0 ? searchRef : {}}
                isLabelReq={true}
                menuPlacement="auto"
                optionPadding={0}
                menuWidth="45rem"
                errorClass="hidden"
                isRequired={false}
                value={
                  values?.tempRowData?.[fieldType]
                    ? {
                        label: values?.tempRowData?.[fieldType],
                        value: "",
                      }
                    : null
                }
                name={`tempRowData.${fieldType}`}
                field={fieldType}
                defaultSelectClass=""
                placeholder={
                  fieldType === "item_code" ? "Item Code" : "Product Name"
                }
                fetchData={fetchData}
                onChange={async (selectedOption) => {
                  setIsLoadingOverlay(true);
                  const foundItem = localData?.find(
                    (item) => item?.item_id === selectedOption?.value
                  );
                  const mappedItem = foundItem
                    ? {
                        item_code: foundItem.item_code,
                        item_name: foundItem.item_name,
                        item_quantity: 0,
                        item_correction_quantity: "",
                        updated_quantity: 0,
                        item_id: foundItem?.item_id,
                        item_generic_name: foundItem?.item_generic_name,
                        item_uom_id: foundItem.item_uom,
                        item_uom: "",
                        item_exp_date: "",
                        item_mfg_date: "",
                        item_total_amount: 0,
                        correction: "-",
                        item_current_amount: 0,
                        item_adjusted_amount: "",
                        item_current_adjusted_diff: "",
                        to_bin_id: "",
                        item_rack_location: "",
                        is_stock_draft: false,
                        created_by: "",
                      }
                    : null;

                  dispatch(
                    producBatchDetailsAction(
                      {
                        item_id: mappedItem?.item_id,
                      },
                      (data) => {
                        onSuccessBatchDetails(data, mappedItem);
                      },
                      onErrorDetails
                    )
                  );
                }}
              />
            </div>
          ))}

          <div
            onClick={() => {
              if (
                values?.tempRowData?.item_name &&
                values?.tempRowData?.item_Batch_List?.length > 0
              ) {
                setBatchModalOpen(true);
              }
            }}
            className="min-w-[10%] max-w-[10%] cursor-pointer"
          >
            <div style={{ pointerEvents: "none" }}>
              <ItemsInputField
                disabled={true}
                name={`tempRowData.item_batch_number`}
                label="Batch Number"
                isLabelReq={true}
                placeholder="Batch no"
              />
            </div>
          </div>

          <div className={"max-w-[8%] min-w-[8%]"}>
            <ItemsInputField
              disabled={true}
              name={`tempRowData.item_uom`}
              label="UOM"
              isLabelReq={true}
              placeholder="UOM"
            />
          </div>
          <div className={"max-w-[10%] min-w-[10%]"}>
            <ItemsInputField
              disabled={true}
              name={`tempRowData.item_batch_purchase_rate`}
              label="Price"
              isLabelReq={true}
              placeholder="Price"
            />
          </div>
          <div className={"max-w-[10%] min-w-[10%]"}>
            <ItemsInputField
              disabled={true}
              name={`tempRowData.item_quantity`}
              label="Available Qty"
              isLabelReq={true}
              placeholder="AQTY"
            />
          </div>
          <div className={"max-w-[10%] min-w-[10%]"}>
            <ItemsInputField
              ref={corr_ref}
              disabled={false}
              name={`tempRowData.item_correction_quantity`}
              label="Correction (+ / -)"
              isLabelReq={true}
              placeholder="Correction"
              onChange={(e) => {
                const value = e.target.value;

                // Allow only +, - and digits (no decimal)
                const sanitized = value.replace(/[^0-9+-]/g, "");
                const valid = /^[-+]?\d*$/.test(sanitized) ? sanitized : "";

                setFieldValue("tempRowData.item_correction_quantity", valid);

                // Parse and calculate updated quantity
                const currentQty = parseInt(
                  values?.tempRowData?.item_quantity || 0,
                  10
                );
                const correctionQty = parseInt(valid, 10);

                if (!isNaN(correctionQty)) {
                  const updatedQty = currentQty + correctionQty;
                  setFieldValue("tempRowData.updated_quantity", updatedQty);
                } else {
                  setFieldValue("tempRowData.updated_quantity", currentQty);
                }
              }}
              onKeyDown={(event) => {
                if (
                  // event.key === "-" ||
                  event.key === "e" ||
                  event.key === "."
                ) {
                  event.preventDefault();
                }
                if (event.key === "Tab" || event.key === "Enter") {
                  if (!event?.target?.value) {
                    errorToast("correction Qty is Required");
                    corr_ref?.current?.focus();
                  } else {
                    event.preventDefault(); // Prevent default behavior
                    setIsLoadingOverlay(true);
                    auditFn(values?.tempRowData);
                  }
                }
              }}
            />
          </div>

          <div className={"max-w-[10%] min-w-[10%]"}>
            <ItemsInputField
              disabled={true}
              name={`tempRowData.updated_quantity`}
              label="Updated Qty"
              isLabelReq={true}
              placeholder="Updated Qty"
            />
          </div>
        </div>
      )}

      <div
        style={{
          maxHeight: `calc(100% - ${disabled ? "0rem" : "5.5rem"} )`,
          minHeight: `5rem`,
        }}
        className={`tab-container border-radius ${disabled ? "mt-[1rem]" : ""}`}
      >
        <table className="w-full border-collapse mt-0">
          <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
            <tr className="relative h-[50px]">
              {heading
                ?.filter((heading) => heading?.enabled !== false)
                ?.map((heading, index) => (
                  <th
                    style={{ minWidth: `${heading?.minWidth}px` }}
                    key={index}
                    className={`px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                  >
                    {heading?.value === "clear_all" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent:
                            heading?.alignment === "right"
                              ? "flex-end"
                              : heading?.alignment === "center"
                              ? "center"
                              : "flex-start",
                          width: "100%", // Ensure the div takes full width of the th
                        }}
                      >
                        {!disabled && (
                          <AddButton
                            type="button"
                            onclkFn={() => {
                              if (values?.stockAuditRecordData?.length > 0) {
                                removeRow(0, "all");
                              }
                            }}
                            prefixIcon={false}
                            text={"Clear All"}
                            className="flex items-center px-[10px] py-[10px] h-[20px] whitespace-nowrap border-radius gap-[8px]
                 bg-[var(--create-table-clearAll-bg)] 
                 cursor-pointer 
                 text-[var(--create-table-clearAll-color)] 
                 text-[length:var(--create-table-clearAll-fs)] 
                 font-[var(--create-table-clearAll-fw)] 
                 border-2 border-[var(--create-table-clearAll-border)] 
                 hover:bg-[var(--create-table-clearAll-bg)]"
                          />
                        )}
                      </div>
                    ) : (
                      <div
                        className="flex items-center gap-2 w-full text-nowrap"
                        style={{
                          justifyContent:
                            heading?.alignment === "right"
                              ? "flex-end"
                              : heading?.alignment === "center"
                              ? "center"
                              : "flex-start",
                        }}
                      >
                        {heading?.label}
                      </div>
                    )}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="h-full">
            {values?.stockAuditRecordData?.map((rowData, rowIndex) => (
              <tr
                className={`hover:bg-[var(--create-table-row-hover-bg)] ${
                  rowIndex % 2 === 0
                    ? " bg-[var(--create-table-row-alt-bg)]"
                    : " bg-[var(--create-table-row-bg)]"
                }   h-[50px] `}
                key={rowIndex}
              >
                {heading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => {
                    return (
                      <td
                        style={{
                          minWidth: `${heading?.minWidth}px`,
                          textAlign: heading?.alignment, // Keep textAlign for normal text cells
                        }}
                        key={index}
                        className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                      >
                        {heading.value === "sl_no" ? (
                          <div>
                            <input
                              type="checkbox"
                              name="SerialNumberRadioGroup"
                              value={rowIndex}
                              className="peer hidden"
                              id={`alt-${rowIndex}`}
                              onChange={() => {
                                if (selectedItem?.index === rowIndex) {
                                  setSelectedItem({
                                    itemid: "",
                                    index: null,
                                    item_name: "",
                                    item_batch_number: "",
                                  });
                                } else {
                                  setSelectedItem({
                                    itemid: rowData?.item_id,
                                    item_name: rowData?.item_name,
                                    item_batch_number:
                                      rowData?.item_batch_number,
                                    index: rowIndex,
                                  });

                                  setFieldValue("tempRowData", rowData);
                                }
                              }}
                              checked={selectedItem?.index === rowIndex}
                            />
                            <label
                              htmlFor={`alt-${rowIndex}`}
                              className={`block cursor-pointer select-none border-radius  text-center hover:bg-slate-100 w-[3.5rem] py-[12px] ${
                                selectedItem?.index === rowIndex
                                  ? "font-bold outline-none ring-2 ring-[var(--primary)] bg-[var(--create-table-row-sel-bg)]"
                                  : ""
                              }`}
                            >
                              {rowIndex + 1}
                            </label>
                          </div>
                        ) : heading.value === "clear_all" ? (
                          <button
                            type="button"
                            onClick={() => {
                              removeRow(rowIndex, "");
                            }}
                            style={{
                              display: "flex",
                              justifyContent:
                                heading?.alignment === "right"
                                  ? "flex-end"
                                  : heading?.alignment === "center"
                                  ? "center"
                                  : "flex-start",
                              width: "100%", // Take full width of the td
                            }}
                          >
                            {!disabled && (
                              <DeleteIcon className="cursor-pointer text-red-500" />
                            )}
                          </button>
                        ) : (
                          rowData[heading.value] ?? "--"
                        )}
                      </td>
                    );
                  })}
              </tr>
            ))}
          </tbody>
        </table>
        <LoadingOverlay isLoading={isLoadingOverlay} />
      </div>
      <BatchSelectionModal
        dynamicKey="stockAuditRecordData"
        heading={batchheading}
        isOpen={batchModalOpen}
        setIsOpen={setBatchModalOpen}
        batches={values?.tempRowData?.item_Batch_List || []}
        onSelect={(selectedBatch) => {
          if (selectedBatch?.item_batch_number) {
            const updatedTempRowData = {
              ...values?.tempRowData,
              item_quantity: selectedBatch?.item_quantity ?? 0,
              item_exp_date:
                moment(selectedBatch?.item_exp_date).format("YYYY-MM-DD") ??
                null,
              item_mfg_date: selectedBatch?.item_mfg_date || null,
              item_batch_purchase_rate:
                (
                  parseFloat(selectedBatch?.item_batch_final_purchase_rate) /
                  parseFloat(selectedBatch?.item_pack_size)
                ).toFixed(2) || "",
              item_batch_number: selectedBatch?.item_batch_number ?? "",
              item_uom_id: selectedBatch?.item_uom_id ?? "",
              item_uom: selectedBatch?.item_uom ?? "",
              item_rack_location: selectedBatch?.item_rack_location,
              item_pack_size: parseFloat(selectedBatch?.item_pack_size) || 0,
            };
            setFieldValue("tempRowData", updatedTempRowData);
            setBatchModalOpen(false);
            setTimeout(() => {
              corr_ref?.current?.focus();
            }, 300);
          } else {
            errorToast("Batches not present");
            setFieldValue("tempRowData", initialValues?.tempRowData);
            setBatchModalOpen(false);
          }
        }}
      />
    </div>
  );
};

export default AuditItemsSection;
const heading = [
  { label: "SR No.", value: "sl_no" },
  { label: "Item Code", value: "item_code" },
  { label: "Generic Name", value: "item_generic_name" },
  { label: "Product Name", value: "item_name" },
  { label: "Pack Size", value: "item_pack_size" },
  { label: "Batch No.", value: "item_batch_number" },
  { label: "Exp. Date", value: "item_exp_date" },
  { label: "Bin Location", value: "item_rack_location" },
  { label: "Mfg. Date", value: "item_mfg_date" }, // Assuming you have this field
  { label: "Available Qty", value: "item_quantity" }, // Captured during audit creation
  { label: "Correction Qty", value: "item_correction_quantity" }, // Assuming you'll have this
  { label: "Updated Qty", value: "updated_quantity" },
  { label: "Total (₹)", value: "item_total_amount" }, // Updated Qty * Final Purchase Rate
  { label: "Clear All", value: "clear_all" },
];
